import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { api } from "@/lib/api";
import { useCustomerAuth, startGoogleLogin } from "@/context/CustomerAuthContext";
import { toast } from "sonner";

export default function WishlistHeart({ productId, size = "md", className = "" }) {
  const { user } = useCustomerAuth();
  const [inList, setInList] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!user) {
      setInList(false);
      return;
    }
    api.get("/customer/wishlist", { withCredentials: true })
      .then(({ data }) => setInList((data.product_ids || []).includes(productId)))
      .catch(() => {});
  }, [user, productId]);

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      toast("Sign in to save pieces to your wishlist");
      startGoogleLogin(window.location.pathname);
      return;
    }
    if (busy) return;
    setBusy(true);
    try {
      if (inList) {
        await api.delete(`/customer/wishlist/${productId}`, { withCredentials: true });
        setInList(false);
      } else {
        await api.post("/customer/wishlist", { product_id: productId }, { withCredentials: true });
        setInList(true);
        toast.success("Saved to wishlist");
      }
    } catch {
      toast.error("Could not update wishlist");
    } finally {
      setBusy(false);
    }
  };

  const sizeMap = {
    sm: "w-8 h-8",
    md: "w-9 h-9",
    lg: "w-11 h-11",
  };
  const iconSize = { sm: "w-3.5 h-3.5", md: "w-4 h-4", lg: "w-5 h-5" }[size];

  return (
    <button
      onClick={toggle}
      data-testid={`wishlist-toggle-${productId}`}
      aria-label={inList ? "Remove from wishlist" : "Add to wishlist"}
      className={`${sizeMap[size]} rounded-full bg-white/90 hover:bg-white backdrop-blur flex items-center justify-center shadow-sm transition-transform hover:scale-105 ${className}`}
    >
      <Heart
        strokeWidth={1.5}
        className={`${iconSize} ${inList ? "fill-[#8B3A3A] text-[#8B3A3A]" : "text-[#1A1C1A]"}`}
      />
    </button>
  );
}
